// Libraries
import Axios from 'config/service.config'
import envConfig from 'config/env_config'

export const getAllMyPets = async (id) => {
  try {
    const { data } = await Axios({ baseURL: envConfig.pet, url: '/pets/user', withCredentials: true })
    return data
  } catch (error) {
    return error.response
  }
}
